const STORAGE_KEY = 'napster-pending-offer';
const MAX_AGE_MS = 60 * 60 * 1000;
const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const CODE_PATTERN = /^[A-Za-z0-9-]{4,40}$/;

/** Covers sign-ins that lose their return URL, like verifying email in another tab */
export const rememberPendingOffer = (slug: string, code?: string): void => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ slug, code, at: Date.now() }),
    );
  } catch {
    // storage can be unavailable (private mode); the return URL still works
  }
};

export const clearPendingOffer = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // nothing to clear
  }
};

export const offerClaimPath = (slug: string, code?: string): string =>
  code
    ? `/offers/${slug}?code=${encodeURIComponent(code)}&claim=1`
    : `/offers/${slug}`;

/** The claim step of a recently started offer, consumed on read. */
export const takePendingOfferPath = (): string | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    localStorage.removeItem(STORAGE_KEY);

    const { slug, code, at } = JSON.parse(raw) as {
      slug?: unknown;
      code?: unknown;
      at?: unknown;
    };
    if (typeof slug !== 'string' || !SLUG_PATTERN.test(slug)) return null;
    if (typeof at !== 'number' || Date.now() - at > MAX_AGE_MS) return null;
    return offerClaimPath(
      slug,
      typeof code === 'string' && CODE_PATTERN.test(code) ? code : undefined,
    );
  } catch {
    return null;
  }
};
